import type React from "react";
import { useAuth } from "@/context/AuthContext";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { OverviewStats } from "@/components/overview-stats";
import { FeatureUsageChart } from "@/components/feature-usage-chart";
import { Activities } from "@/components/activities";

const Dashboard: React.FC = () => {
  const { user } = useAuth();

  // Function to get time-based greeting
  const getTimeBasedGreeting = (): string => {
    const hour = new Date().getHours();
    if (hour < 12) return "Good morning";
    if (hour < 17) return "Good afternoon";
    return "Good evening";
  };

  // Function to extract user name from email
  const getUserName = (): string => {
    if (!user?.email) return "User";
    
    // Extract name from email (e.g., "john.doe@company.com" -> "John Doe")
    const emailPrefix = user.email.split('@')[0];
    const nameParts = emailPrefix.split(/[._-]/);
    
    // Capitalize first letter of each part
    const capitalizedName = nameParts
      .map((part: string) => part.charAt(0).toUpperCase() + part.slice(1))
      .join(' ');
    
    return capitalizedName || "User";
  };

  const greeting = getTimeBasedGreeting();
  const userName = getUserName();

  return (
    <>
      <main className="flex-1 space-y-6 p-2">
        <div className="space-y-2">
          <h2 className="text-3xl font-bold tracking-tight bg-gradient-to-r from-pink-500 to-purple-500 bg-clip-text text-transparent">
            {greeting}, {userName}!
          </h2>
          <p className="text-muted-foreground">
            Monitor your AI-powered visual commerce tools and analytics
          </p>
        </div>

        {/* Overview Stats */}
        <OverviewStats />

        {/* Feature Usage Chart */}
        <Card>
          <CardHeader>
            <CardTitle>Feature Usage</CardTitle>
            <CardDescription>
              Usage statistics across all features
            </CardDescription>
          </CardHeader>
          <CardContent>
            <FeatureUsageChart />
          </CardContent>
        </Card>

        {/* Recent Activity Section - Expanded */}
        <Card>
          <CardHeader>
            <CardTitle>Recent Activity</CardTitle>
            <CardDescription>
              Latest events and actions across all features
            </CardDescription>
          </CardHeader>
          <CardContent>
            <Activities compact={false} />
          </CardContent>
        </Card>


      </main>
    </>
  );
};

export default Dashboard;
